import { ISettings, SETTINGS } from '../init';
import rmnApi from './rmnApi';
import rmnBeacon from './rmnBeacon';

/**
 * This function adds either an `account_id` (for 'api' mode) or a `marketplace_id`
 * (for 'proxy' mode) to the provided base parameters. The mode is determined by
 * `SETTINGS.MODE`, defaulting to 'proxy' if not specified.
 */
export function generateEventRequestPayload<T extends Record<string, unknown>>(
  params: T,
) {
  switch (SETTINGS.MODE) {
    case 'api': {
      return {
        account_id: SETTINGS.ACCOUNT_ID,
        ...params,
      };
    }
    case 'proxy':
    default:
      return {
        marketplace_id: SETTINGS.MARKET_PLACE_ID,
        ...params,
      };
  }
}

const PATH: Record<ISettings['MODE'], string> = {
  proxy: '/v0/proxy/events',
  api: '/v0/events',
};

export const apiPostEvent = async (requestBody: unknown): Promise<unknown> => {
  // @ts-expect-error: for some browsers do not support sendBeacon
  if (navigator?.sendBeacon) {
    rmnBeacon(PATH[SETTINGS.MODE], requestBody);
  } else {
    return rmnApi(PATH[SETTINGS.MODE], requestBody);
  }
};
